module.exports = __webpack_public_path__ + "img/icon_clock.4d7c837c.svg";